<template>
    <div>        
        <div class="row">
            <div class="col-md-6">
                Optional Items:<br/>
                <select class="uniqueItemOptions form-control" multiple="multiple" placeholder="Select Item Options" v-model="uniqueItemOptions">
                    <optgroup label="Packages" v-if="packages && packages.length">
                        <option v-for="pack in packages" :value="'k-'+pack.id" :key="pack.id">{{ pack.name }}</option>
                    </optgroup>
                    <optgroup label="Deals" v-if="deals && deals.length">
                        <option v-for="deal in deals" :value="'d-'+deal.id" :key="deal.id">{{ deal.name }}</option>
                    </optgroup>
                    <optgroup label="Products" v-if="products && products.length">
                        <option v-for="product in products" :value="'p-'+product.id" :key="product.id">{{ product.name }}</option>
                    </optgroup>
                </select>
            </div>
            <div class="col-md-2">
                Min Items:<br/>
                <input type="number" class="uniqueItemMinQty form-control" v-model="requirement.settings.min_qty" min="0" />
            </div>
            <div class="col-md-2">
                Max Items:<br/>
                <input type="number" class="uniqueItemMaxQty form-control" v-model="requirement.settings.max_qty" min="0" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        requirement: Object,
        packages: Array,
        deals: Array,
        products: Array
    },
    data: () => {
        return {
            uniqueItemOptions: []
        }
    },
    methods: {
        selectuniqueItemOptions() {
            var vm = this;
            if(this.requirement.settings.hasOwnProperty('package_ids') && this.requirement.settings.package_ids.length > 0) {
                this.requirement.settings.package_ids.map(function(value) {
                    vm.uniqueItemOptions.push('k-'+value)
                });
            }
            if(this.requirement.settings.hasOwnProperty('deal_ids') &&this.requirement.settings.deal_ids.length > 0) {
                this.requirement.settings.deal_ids.map(function(value) {
                    vm.uniqueItemOptions.push('d-'+value)
                });
            }
            if(this.requirement.settings.hasOwnProperty('product_ids') &&this.requirement.settings.product_ids.length > 0) {
                this.requirement.settings.product_ids.map(function(value) {
                    vm.uniqueItemOptions.push('p-'+value)
                });
            }
        },
        updateUniqueItemOptions() {
            var packageIds = [];
            var dealIds = [];
            var productIds = [];
            var min_qty = this.requirement.settings.min_qty;
            var max_qty = this.requirement.settings.max_qty;
            if(this.uniqueItemOptions) {
                this.uniqueItemOptions.map(function(itemTypeId) {
                    var typeItem = itemTypeId.split('-');
                    
                    if( typeItem[0] == 'k' ) {
                        packageIds.push(Number(typeItem[1]));
                    }else if( typeItem[0] == 'd' ) {
                        dealIds.push(Number(typeItem[1]));
                    }else if( typeItem[0] == 'p' ) {
                        productIds.push(Number(typeItem[1]));
                    }
                });
            }
            this.requirement.settings = {
                package_ids: packageIds,
                deal_ids: dealIds,
                product_ids: productIds,
                min_qty: min_qty,
                max_qty: max_qty
            }
        }
    },
    mounted() {
        this.selectuniqueItemOptions();
    },
    watch: {
        uniqueItemOptions() {
            this.updateUniqueItemOptions();
        }
    }
}
</script>